<template>
  <div class="verticaltab-container">
    <ul class="verticaltab-list">
      <li v-for="(item, index) in tablist" :key="'tablist' + index" class="verticaltab-item-wrap">
        <a
          @click="clickTab(index + 1)"
          tabindex="0"
          class="verticaltab-item cursor"
          :class="selecttab === index + 1 ? 'active' : ''"
        >
          {{ item }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    selecttab: {
      type: Number,
      default: 1,
      required: false
    },
    tablist: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    }
  },
  emits: ['click-tab'],
  methods: {
    clickTab(tabVal) {
      this.$emit('click-tab', tabVal);
    }
  }
};
</script>
<style scoped src="@/assets/css/commonverticaltab/commonverticaltab.css"></style>
